import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { cascaderClass } from './styles';
import { focusElement, getCursorOffset, preventPasteFile } from '../utils/dom/element';

var handleFocus = function handleFocus(e) {
  e.stopPropagation();
};

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    _this = _super.call(this, props);
    _this.lastCursorOffset = void 0;
    _this.editElement = void 0;
    _this.blurTimer = void 0;
    _this.state = {
      editable: false
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    _this.handlePaste = _this.handlePaste.bind(_assertThisInitialized(_this));
    _this.focusInput = _this.focusInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusInput(true);
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(text) {
      var trim = this.props.trim;
      if (!trim && this.lastCursorOffset === 0 && /^\u00A0$/.test(text)) return '';
      return trim ? text.trim() : text.replace(/\u00A0/g, ' ');
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this$props = this.props,
          _this$props$emptyAfte = _this$props.emptyAfterSelect,
          emptyAfterSelect = _this$props$emptyAfte === void 0 ? true : _this$props$emptyAfte,
          multiple = _this$props.multiple;

      if (this.editElement) {
        if (!(multiple && !emptyAfterSelect)) {
          this.editElement.innerText = '';
        }
      }

      if (this.blurTimer) clearTimeout(this.blurTimer);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      var _this2 = this;

      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!flag) {
        this.setState({
          editable: false
        });
        return;
      }

      this.setState({
        editable: true
      }, function () {
        return _this2.focus();
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this3 = this;

      requestAnimationFrame(function () {
        focusElement.end(_this3.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var text = e.target.innerText.replace('\feff ', '');
      this.lastCursorOffset = getCursorOffset(text.length);
      var t = this.getProcessedValue(text);
      this.props.onFilter(t);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "handlePaste",
    value: function handlePaste(e) {
      preventPasteFile(e);
    }
  }, {
    key: "render",
    value: function render() {
      var focus = this.props.focus;
      var props = {
        className: cascaderClass('input', !focus && 'ellipsis'),
        ref: this.bindElement,
        key: 'input',
        onInput: this.handleInput,
        contentEditable: focus || this.state.editable,
        onFocus: handleFocus,
        onPaste: this.handlePaste
      };
      return (
        /*#__PURE__*/
        React.createElement("span", props)
      );
    }
  }]);

  return FilterInput;
}(Component);

export default FilterInput;